<template>
  <div class="web-container">
    <iframe :src="resultUrl"></iframe>
  </div>
</template>


<script>
export default {

  data() {
    return {
      pageTitle: this.$route.meta.title,
      resultUrl: "",
      changeTitle:""
    };
  },


  mounted() {
    this.resultUrl = this.$route.query.url;
    this.changeTitle = this.$route.query.title;
  },

  methods: {
    updateTitle() {
      this.$route.meta.title = '新标题'; // 更新标题
      this.pageTitle = this.$route.meta.title; // 更新页面显示的标题
      document.title = this.$route.meta.title; // 更新页面标题
    },
  },
};
</script>

<style lang="scss" scoped>
.web-container {
  width: 100%;
  height: 100vh; // 或者你可以使用其他方式让它撑满父级
  display: flex;
}

iframe {
  width: 100%;
  height: 100%;
  border: none;
}
</style>
